import { dispatch } from '@src/dispatcher';

// Constants
import { ActionTypes } from '@src/constants/MogamboConstants';
import { PERMISSION_LEVELS } from '@src/const';

// API
import * as Api from '@src/api';

// Utils
import { userHasPermission, permissionErrorAlert } from './_utils';

export function getAllBusinessList(cb) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_VIEW)) {
    permissionErrorAlert('fetch business list');
    return;
  }

  dispatch(ActionTypes.START_LOADING, {
    message: 'Fetching Business List.',
  });

  Api.getAllBusinessList(cb);
}

export function toggleBusinessListLoading() {
  dispatch(ActionTypes.TOGGLE_BUSINESS_LIST_LOADING);
}
